import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'

export const ITEMS_PER_PAGE = 20
export const SIGNIFICANT_TRANSACTIONS_CATEGORIES = [
  ESecondCategories.SIGNIFICANT_TRANSACTION,
]

